module.exports = "//public.zight.com/packs/media/images/dashboard-d1a68bbc9e0289c213ccec8fc9125514.svg";